import { TechDocsMetadata } from '@backstage/plugin-techdocs-react';

// The central publisher adds milliseconds since the epoch to TechDocs metadata.
// Older sites and other publishers may omit it; never substitute the current time.
export function generationTime(
  metadata: (TechDocsMetadata & { build_timestamp?: number }) | undefined,
): Date | undefined {
  const timestamp = metadata?.build_timestamp;
  if (
    typeof timestamp !== 'number' ||
    !Number.isFinite(timestamp) ||
    timestamp <= 0
  ) {
    return undefined;
  }

  const date = new Date(timestamp);
  return Number.isNaN(date.getTime()) ? undefined : date;
}
